import i18n from '@/locales/index';
// import useStore from '@/mixins/useStore';
import { computed, ref } from '@vue/composition-api';

export default function useI18n() {
    // const { mainModule } = useStore();
    // const { local } = mainModule.useState(['local']);
    const local = ref('');
    local.value = i18n.locale;

    const isZH = computed(() => {
        return ['zh-CN', 'zh-TW'].includes(local.value);
    });

    function renderKey(key: string, params?: any) {
        const text: string = i18n.t(key, params).toString();
        if (text === key) {
            const arr = key.split('.');
            return arr[arr.length - 1];
        }
        return text;
    }

    return {
        renderKey,
        i18n,
        isZH,
        local,
    };
}
